<template>
    <div :class="['socialLinks', orientation ? 'socialLinks_' + orientation : '']">
        <ul class="socialLinks-list">
            <li v-for="(item, index) of socialLinks" :key="index">
                <a :aria-label="item.label" :href="item.link" target="_blank">
                    <i :class="['icon', 'icon_social', 'icon_social_' + item.class, theme ? 'icon_' + theme : '']"></i>
                    <span class="isVisuallyHidden">{{item.label}}</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import kohlerCorporateConfig from '../../kohlerCorporateConfig';

export default {
    props: ['theme', 'orientation'],
    // TODO: look at this; did we do this correctly? (needed a way to pass down kohlerCorporateConfig)
    computed: {
        socialLinks: () => kohlerCorporateConfig.socialLinks,
    }
}
</script>

<style lang="scss">
</style>